import { IconRecipe } from '../../../../../assets/index';
import moment from 'moment';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { getCommissionHistoryDetail } from '../../../../../features/dashboard/actions';
import { formatMoney } from '../../../../../utils/helpers/helpers';
import './RightDashboard.scss';

const RightDashboard = (props) => {
  const [listData, setListData] = useState([]);
  const fetCommissionHistoryDetail = async () => {
    try {
      const { data } = await getCommissionHistoryDetail();
      setListData(data?.data?.items);
      if (data.code === 200) {
      }
    } catch (err) {}
  };
  useEffect(() => {
    fetCommissionHistoryDetail();
  }, []);
  return (
    <div className='right-dashboard'>
      {listData?.length > 0 ? (
        <>
          <div className='mobile-header-right-tab'>
            <div className='cell-header'>Tháng</div>
            <div className='cell-header'>Thu nhập</div>
          </div>
          {listData?.map((v, index) => (
            <div className='mobile-body-right-tab' key={index}>
              <div className='cell-body'>
                {moment(v?.completedDate, 'DD/MM/YYYY').format('MM/YYYY')}
              </div>
              <div className='cell-body'>
                {`${formatMoney(v.commission || 0)}`}đ
              </div>
            </div>
          ))}
        </>
      ) : (
        <div className='empty-table'>
          <IconRecipe />
          <span style={{ paddingTop: 10 }}>Chưa có dữ liệu</span>
        </div>
      )}
    </div>
  );
};

export default RightDashboard;
